import React from "react";

let scrollFlag = true;
const News = (props) => {
    const style = () => {
        if (props.isActive === false && scrollFlag === true) {
            scrollFlag = false;
            return "active";
        } else {
            return "notActive";
        }
    };

    return (
        <div
            className={props.isLoad ? "add-anim-to-news-mother-wrap" : ""}
            id="news-mother-wrap"
        >
            <div className={`${style()} news-wrap`}>
                <div className={`news`}>
                    <div className="news-text-wrap">
                        <p className="news-text-data">2022.12.9</p>
                        <p className="news-text-main">サイトを更新しました。</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default News;
